import {configureStore, isRejectedWithValue, PayloadAction} from '@reduxjs/toolkit';
import {rootReducer} from 'reducers';
import caches from 'helpers/caches';
import {ApiErrors, AppSessionStorageKeysEnum} from 'types/global';
import {useDispatch} from "react-redux";
import {processError} from "middlewares";

const userSession = caches.locale.getItem(AppSessionStorageKeysEnum.User);

const isApiErrorAction = (
    action: PayloadAction<unknown>
): action is PayloadAction<ApiErrors> => {
    return (
        typeof action.payload === 'object' &&
        action.payload !== null &&
        'message' in action.payload &&
        'code' in action.payload
    );
}


const store = configureStore({
    reducer: rootReducer,
    preloadedState: userSession
        ? {
            auth: {
                isAuthorized: userSession?.isAuthorized ?? '',
                token: userSession?.token ?? '',
                error: null
            },
        }
        : {},
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(() => (next) => (action) => {
            if (isRejectedWithValue(action) && isApiErrorAction(action) && !action.payload.silent) {
                return next(processError(action));
            }

            return next(action);
        }),
});

store.subscribe(() => {
    const state = store.getState();
    caches.locale.setItem({
        type: AppSessionStorageKeysEnum.User,
        data: {
            isAuthorized: state.auth.isAuthorized,
            token: state.auth.token ?? ''
        },
    });
});

export const useAppDispatch = () => useDispatch<AppDispatch>();
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
